import React from 'react'

const StarRating: React.FC<{
  maxRating: number
  rating: number
  numberOfStars?: number
}> = ({ maxRating, rating, numberOfStars }) => {  
  const idPrefix = `${randomIdPrefix()}starRating`
  const normalizedRating = (rating / maxRating) * numberOfStars
  const floorRating = Math.floor(normalizedRating)
  return (
    <div className="block__star-rating">
      {Array.from({ length: numberOfStars }, (_, i) => (
        <StarSVG
          key={i}
          idPrefix={`${idPrefix}-${i}`}
          maskAmount={calculateMaskAmount(i, normalizedRating, floorRating)}
        />
      ))}
    </div>
  )
}

const calculateMaskAmount = (
  starIndex: number,
  rating: number,
  floorRating: number
) => {
  let percentage = ''
  if (starIndex > floorRating) {
    percentage = '0%'
  } else if (starIndex === floorRating) {
    percentage = `${(rating - floorRating) * 100}%`
  } else {
    percentage = '100%'
  }

  return percentage
}

const randomIdPrefix = () => Math.random().toString(36).substring(2, 15)

const StarSVG = ({
  maskAmount,
  idPrefix,
}: {
  maskAmount: string
  idPrefix: string
}) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9635 5.29043C13.8718 4.99462 13.6204 4.78452 13.3229 4.75654L9.28214 4.37368L7.68431 0.47114C7.56649 0.185134 7.29817 0 7.00006 0C6.70194 0 6.43362 0.185134 6.31581 0.471809L4.71797 4.37368L0.676558 4.75654C0.379615 4.78519 0.128816 4.99462 0.0366354 5.29043C-0.0555451 5.58625 0.0295857 5.9107 0.254216 6.11523L3.30856 8.91042L2.40791 13.0504C2.342 13.3548 2.45523 13.6694 2.69727 13.852C2.82737 13.9501 2.97958 14 3.13307 14C3.26541 14 3.39668 13.9628 3.5145 13.8892L7.00006 11.7154L10.4843 13.8892C10.7393 14.0493 11.0607 14.0347 11.3022 13.852C11.5444 13.6689 11.6575 13.3541 11.5916 13.0504L10.6909 8.91042L13.7453 6.11579C13.9699 5.9107 14.0557 5.5868 13.9635 5.29043Z"
        mask={`url(#${idPrefix}-bunnyStarMask)`}
        fill={`url(#${idPrefix}-bunnyStar)`}
      />
      <defs>
        <linearGradient
          id={`${idPrefix}-bunnyStar`}
          x1="14"
          y1="7.03223"
          x2="0.196668"
          y2="5.38461"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7854" />
          <stop offset="0.0154294" stopColor="#FF7954" />
          <stop offset="0.6623" stopColor="#FFA04B" />
          <stop offset="1" stopColor="#FFAF48" />
        </linearGradient>
        <mask id={`${idPrefix}-bunnyStarMask`}>
          <rect x="0" y="0" width="14" height="14" fill="white" />
          <rect x={maskAmount} y="0" width="14" height="14" fill="#222" />
        </mask>
      </defs>
    </svg>
  )
}

export default StarRating
